import { ServiceType } from "./service-type";
import { UnitType } from "./unit-type";

export class UnitTypeService {
	id:number = 0;
	unit_type_id:number = 0;
	unit_type:UnitType = new UnitType();
	service_type_id:number = 0;
	service_type:ServiceType = new ServiceType();
}